import { colors } from "@/components/Providers/ThemeRegistry/theme"
import useWaveOneAddressPointsAttribution from "@/hooks/queryHooks/useWaveOneAddressPointsAttribution"
import { formatAmount } from "@/utils/formatting.utils"
import { Button, Skeleton, alpha } from "@mui/material"

import { SyntheticEvent } from "react"

import { useWallet } from "../Providers/WalletProvider"

export const CampaignPointsEarnedButton = ({ pointsEarned }: { pointsEarned: string | undefined }) => {
  const { isConnected } = useWallet()
  const { isLoading } = useWaveOneAddressPointsAttribution()

  if (!isConnected) {
    return <OutlinedConnectButton preventClick={true} />
  }
  if (isLoading) {
    return <Skeleton variant="rectangular" width="100%" height="40px" />
  }

  if (!pointsEarned || parseFloat(pointsEarned) === 0) {
    return (
      <Button
        fullWidth
        variant="contained"
        size="medium"
        sx={{
          backgroundColor: alpha(colors.base.black, 0.08),
          color: alpha(colors.base.black, 0.4),
          cursor: "inherit",
          "&:hover": {
            backgroundColor: alpha(colors.base.black, 0.08),
            color: alpha(colors.base.black, 0.4),
            boxShadow: "none",
          },
        }}
      >
        Points Earned: 0
      </Button>
    )
  }

  return (
    <Button
      fullWidth
      variant="contained"
      size="medium"
      sx={{
        backgroundColor: alpha(colors.blue.main, 0.1),
        color: colors.blue.main,
        "&:hover": {
          backgroundColor: alpha(colors.blue.main, 0.1),
          color: colors.blue.main,
          boxShadow: "none",
        },
      }}
    >
      Points Earned: {formatAmount(pointsEarned, true, 0, 2)}
    </Button>
  )
}

export const OutlinedConnectButton = ({ preventClick }: { preventClick?: boolean }) => {
  const { connect } = useWallet()

  const handleOnClick = (e: SyntheticEvent) => {
    if (!!connect) {
      connect()
    }
    if (preventClick) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <Button fullWidth variant="outlined" size="medium" onClick={(e) => handleOnClick(e)}>
      Connect Wallet
    </Button>
  )
}
